import gql from 'graphql-tag'

export const INDEX = gql`
  query users_index($page: Int!, $perPage: Int!, $search: String) {
    users(page: $page, perPage: $perPage, search: $search) {
      nodes {
        id
        name
        email
        insertedAt
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
